import { CompanyService } from '../../core/http/service/CompanyService';
import BaseResponse from '../../models/core/BaseResponse';
import OccupationalHealth from '../../models/core/occupationalHealth/OccupationalHealth';
export const FETCH_OCCUPATIONAL_HEALTH: string = 'FETCH_OCCUPATIONAL_HEALTH' 

const sendToAnalytics = (action: string = '', error: any = null) =>{
    console.error(action, error); 
}
 
export const fetchOccupationalHealth = (companyId: string)=>{
    const service: CompanyService = new CompanyService()
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getCompanySaudeOcupacional(companyId)
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON({...response.data})
            const saudesOcupacionais: OccupationalHealth[] = []

            baseResponse.data.forEach((data: any)=>{
                saudesOcupacionais.push(new OccupationalHealth().fromJSON({...data}))
            })
            
           dispatch({
            type: FETCH_OCCUPATIONAL_HEALTH,
            occupHealthList: saudesOcupacionais
           })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const filterOccupationalHealthByName = (searchQuery: string, companyId: string)=>{
    const service: CompanyService = new CompanyService()
    return async (dispatch: any)=>{
        try{
            const response: any = await service.getCompanySaudeOcupacionalByName(companyId, searchQuery)
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON({...response.data})
            const saudesOcupacionaisFiltradas: OccupationalHealth[] = []

            baseResponse.data.forEach((data: any)=>{
                saudesOcupacionaisFiltradas.push(new OccupationalHealth().fromJSON({...data}))
            })

           dispatch({
            type: FETCH_OCCUPATIONAL_HEALTH,
            occupHealthList: saudesOcupacionaisFiltradas
           })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const registerOccupationalHealth = (companyId: string, occupHealth: any)=>{ 
    const service: CompanyService = new CompanyService()
    return async (dispatch: any)=>{ 
        try{ 
            await service.registerSaudeOcupacional(companyId, occupHealth)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const editOccupationalHealth = (companyId: string, occupHealth: any, occupHealthId: string)=>{ 
    const service: CompanyService = new CompanyService()
    return async (dispatch: any)=>{ 
        try{ 
            await service.editSaudeOcupacional(companyId, occupHealthId, occupHealth)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const activateOrDeactivateOccupationalHealth = (companyId: string, occupHealthId: string, isActivate: boolean) => {
    const service: CompanyService = new CompanyService()
    return async (dispatch: any) => {
        try {
            if (isActivate) {
                await service.activateSaudeOcupacional(companyId, occupHealthId)
            } else {
                await service.inactivateSaudeOcupacional(companyId, occupHealthId)
            }
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}